module.exports = __webpack_public_path__ + "img/redalert.b0f62bdf.svg";